import { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import beaconLogo from 'assets/BeaconLogo.svg';
import beaconLogoFull from 'assets/BeaconLogoFull.svg';
import collapseArrow from 'assets/collapseArrow.svg';
import homeButton from 'assets/HomeButtonBlack.svg';

const Sidebar = ({ authUser }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const getBrandLogo = () => {
    // Return customer's custom logos if available, otherwise return default logos

    if (
      authUser?.customer?.customer_logos
      && Object.keys(authUser.customer.customer_logos).length > 0
    ) {
      return isCollapsed
        ? authUser.customer.customer_logos.icon
        : authUser.customer.customer_logos.full;
    }

    return isCollapsed ? beaconLogo : beaconLogoFull;
  };

  return (
    <div
      className={cn(
        'bg-gray-50 transition-all duration-300 min-h-screen sticky top-0 flex flex-col',
        {
          'w-20': isCollapsed,
          'w-40': !isCollapsed,
        }
      )}
    >
      <div className="flex-1">
        <div
          className="flex items-center justify-left px-7 py-5 mt-8 flex items-center justify-center
          border-b border-b-['#E1E4E8']"
        >
          <img
            src={getBrandLogo()}
            alt="Beacon Logo"
            className={cn(
              'transition-opacity duration-300 opacity-100',
              {
                'w-6': isCollapsed,
              }
            )}
          />
        </div>

        <div className="flex items-center gap-12 px-16 py-2 rounded-md mx-12 my-16 bg-gray-100">
          <img src={homeButton} alt="Home" className="w-5 h-5" />
          {!isCollapsed && (
            <span className="text-sm font-medium text-gray-900">
              Dashboard
            </span>
          )}
        </div>
      </div>

      <div className="p-5 border-t border-t-['#E1E4E8']">
        <button
          onClick={toggleSidebar}
          className={cn(
            'flex items-center justify-center py-1 rounded-md transition-colors duration-200',
            {
              'w-full': isCollapsed,
            }
          )}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <img
            src={collapseArrow}
            alt="Toggle sidebar"
            className={cn(
              'transition-transform duration-300',
              {
                'rotate-180': isCollapsed,
                'rotate-0': !isCollapsed,
              }
            )}
          />
        </button>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  authUser: PropTypes.object,
};

export default Sidebar;
